import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'

import ParentDashboardPage from 'app/pages/Dashboard/ParentDashboard'
import TeacherDashboardPage from 'app/pages/Dashboard/Teacherdashboard'

/**
 * Unified Search page — same consolidation pattern used for Users / Orders /
 * Programs / Sessions / Enrolments. The two underlying screens (Parent
 * Dashboard, Teacher Dashboard) are both "pick a user, then drill in" lookup
 * tools, so they live behind one sidebar entry ("Search") with internal
 * Parent / Teacher tabs.
 *
 * Routes:
 *   /home/parent   → Parent tab
 *   /home/teacher  → Teacher tab
 * Both registered in navigationMenus; only the parent path is sidebar-visible.
 */

const TAB_DEFS = [
  {
    key: 'parent',
    label: 'Parent',
    path: navigationPaths.parentdashboard,
    Component: ParentDashboardPage
  },
  {
    key: 'teacher',
    label: 'Teacher',
    path: navigationPaths.teacherdashboard,
    Component: TeacherDashboardPage
  }
]

const Dashboard = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const activeTab =
    TAB_DEFS.find((t) => pathname === t.path)?.key ?? TAB_DEFS[0].key

  const handleTabChange = (_, value) => {
    if (value === activeTab) return
    const def = TAB_DEFS.find((t) => t.key === value)
    if (def) history.push(def.path)
  }

  const ActiveComponent =
    TAB_DEFS.find((t) => t.key === activeTab)?.Component ?? TAB_DEFS[0].Component

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {TAB_DEFS.map((t) => (
            <Tab key={t.key} label={t.label} value={t.key} />
          ))}
        </Tabs>
      </PageTabsBar>
      <ActiveComponent />
    </>
  )
}

export default Dashboard
